export const INTERVIEW_FETCH_SUCCESS = 'INTERVIEW_FETCH_SUCCESS';

export const interviewSuccess = (positions: any) => ({
  type:INTERVIEW_FETCH_SUCCESS,
  payload: positions
});